'use client';

import { useEffect } from 'react';

// Same as _app: marks that hydration ran, which disarms the no-JS reveal fallback (globals.css).
export const HydrationMarker = () => {
  useEffect(() => {
    document.documentElement.setAttribute('data-hydrated', '');
  }, []);
  return null;
};
